module.exports = __webpack_public_path__ + "static/media/Chart.2679fb76.svg";